import React, {useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import Timer from "./Timer";
import { getDirection, pexios, toast } from "../../utils/functions";
import { isCellPhone } from "../../utils/validator";
import { toast as toast2 } from 'react-toastify';
import {history} from "../../utils/variables";
import { useTranslation } from 'react-i18next';

export default function LoginComponent({ type = '', getData, getStep = () => {}, lossesLogin = false }) {

    const [login, setLogin] = useState({
        fname: '',
        lname: '',
        mobile: [0,9].concat(Array(9).fill('')),
        code: Array(4).fill(''),
    });
    const { t, i18n } = useTranslation();
    const [step, setStep] = useState(1);
    const [signupRequired, setSignupRequired] = useState(false);
    const [timer, setTimer] = useState(true);
    const [loader, setLoader] = useState(false);

    const user = useSelector(store => store.user);
    ////
    // const [test,setTest] = useState('')
    // const [isPesian,sertIsPersian] =useState(false);
    const [index,setIndex] = useState(step === 1 ? 2: 0);

    useEffect(()=>{
        setIndex(step === 1 ? 2: 0)
    },[step])

    // function isLangPersian(e) {
    //     // const index = 0;
    //     // const i =  e.key.charCodeAt(index);
    //     // if((i >= 1574 && i <= 1740) || i === 66){
    //     //     sertIsPersian(true)
    //     // }else{
    //     //     sertIsPersian(false)
    //     // }

    //      setTest(navigator.language)
    //     if(terms.includes(e.key) || e.keyCode === 'Backspace'){
    //         sertIsPersian(true)
    //     }else{
    //         sertIsPersian(false)
    //     }
    // }

    function changeText(value, name) {
        //
        // toast2.dismiss();
        // if(['fname','lname'].includes(name)){
        //     isPesian ?
        //         setLogin(prevState => ({
        //             ...prevState,
        //             [name]: value,
        //         }))
        //         :
        //         toast('لطفا فقط از حروف فارسی استفاده کنید!', 'error');
        // }else{
            setLogin(prevState => ({
                ...prevState,
                [name]: value,
            }));
        //}

    }

    function handleFocus(type){
        document.getElementById(`${type}-${index}`).focus();
    }
    function resetInputBox(type){
        if(type ==='code'){
            setLogin(prevState => ({
                ...prevState,
                code: Array(4).fill(''),
            }));
            setIndex(step === 1 ? 2: 0);
            document.getElementById(`code-0`).focus()
        }else{
            setLogin(prevState => ({
                ...prevState,
                mobile: [0,9].concat(Array(9).fill('')),
                code: Array(4).fill(''),
            }));
            setIndex(step === 1 ? 2: 0)
        }
    }

    function submitMobile() {
        if (lossesLogin && login.mobile.join('') === user.mobile) {
            // setLogin(prevState => ({
            //     ...prevState,
            //     mobile: [0,9].concat(Array(9).fill('')),
            //     code: Array(4).fill(''),
            // }));
            // setIndex(step === 1 ? 2: 0)
            resetInputBox('mobile')
            toast(t('Culprit and losses mobile had to be different'), 'error');
            return;
        }
        const isCellphoneValid = isCellPhone(login.mobile.join(''));
        if (!isCellphoneValid) {
            // setLogin(prevState => ({
            //     ...prevState,
            //     mobile: [0,9].concat(Array(9).fill('')),
            //     code: Array(4).fill(''),
            // }));
            // setIndex(step === 1 ? 2: 0)
            resetInputBox('mobile')
            toast(t('Mobile number is not valid'), 'error');
            return;
        }
        setLoader(true);
        lossesLogin ?
        pexios('/api/login', 'post', {mobile: login.mobile.join('') ,loss_fullname :user.full_name})
            .then(res => {
                changeStep(2);
                setSignupRequired(!res.data.msg);
                setLoader(false);
            })
        :
        pexios('/api/login', 'post', {mobile: login.mobile.join('')})
            .then(res => {
                changeStep(2);
                setSignupRequired(!res.data.msg);
                setLoader(false);
            });
    }
    function submitCode() {
        setLoader(true);
        toast2.dismiss();
        const loginData = {
            ...login,
            mobile: login.mobile.join(''),
            code: login.code.join(''),
        }
        if(loginData.code.length >0){
            if(!signupRequired || (login.fname.length>1 && login.lname.length>1)) {
                pexios('/api/check_code', 'post', loginData)
                    .then(res => {
                        setLoader(false);
                        getData(res.data.data);
                    })
                    .catch(err => {
                        if (err.response.data.msg === 'IncorrectCode') {
                            // setLogin(prevState => ({
                            //     ...prevState,
                            //     code: Array(4).fill(''),
                            // }));
                            // setIndex(step === 1 ? 2 : 0)
                            // document.getElementById(`code-0`).focus();
                            resetInputBox('code');
                            setLoader(false);
                            toast(t('Code is wrong'), 'error');
                        }
                    });
            }else{
                setLoader(false);
                toast(t('Enter your first name and last name'), 'error');
            }
        }else{
            setLoader(false);
            toast(t('Please enter code'), 'error');
        }

    }
    function resendCode() {
        setLoader(true);
        pexios('/api/resend_code', 'post', { mobile: login.mobile.join('') })
            .then(() => {
                setTimer(true);
                setLoader(false);
                // setLogin(prevState => ({
                //     ...prevState,
                //     code: Array(4).fill(''),
                // }));
                // setIndex(step === 1 ? 2: 0)
                //document.getElementById(`code-0`).focus();
                resetInputBox('code');
            });
    }
    function changeStep(step) {
        setStep(step);
        getStep(step);
    }


    function deleteNumberChecking (event ,type){
        const total = type === "mobile" ? 11:4;
         if(event.key === 'Backspace'){
                if(index === total-1 && document.getElementById(`${type}-${index}`).value !== ''){
                    const copyLogin = type === "mobile" ? login.mobile:login.code;
                    copyLogin[index] = ''
                    setLogin(prevState => ({
                        ...prevState,
                        [type]:copyLogin
                    }))
                }else if(type === "mobile" ? index !== 2 :index !== 0){
                    const copyLogin = type === "mobile" ? login.mobile:login.code;
                    copyLogin[index-1] = ''
                    setLogin(prevState => ({
                        ...prevState,
                        [type]:copyLogin
                    }))
                    setIndex(index-1)
                    document.getElementById(`${type}-${index-1}`).focus();
                }
            }
    }
    function handleChangeNumber (event,type){
        const total = type === "mobile" ? 11:4;
        if(index === total-1 &&(type === "mobile" ? !login.mobile[index]: !login.code[index])){ ///if it's last index and empty
            const copyLogin = type === "mobile" ? login.mobile:login.code;
            copyLogin[index] = event.target.value
            setLogin(prevState => ({
                ...prevState,
                [type]:copyLogin
            }))
            ///if code and fname and lname exist
            if(type === "code" && copyLogin[total-1]!== ''&& (!signupRequired || (login.fname.length>1 && login.lname.length>1))){
                submitCode();
            }
        }else if(index < total-1){
            const copyLogin = type === "mobile" ? login.mobile:login.code;
            copyLogin[index] = event.target.value
            setLogin(prevState => ({
                ...prevState,
                [type]:copyLogin
            }))
            setIndex(index+1)
            document.getElementById(`${type}-${index+1}`).focus();
        }
    }

    return (
        step === 1 ?
            <div className="login-input" data-dir={getDirection(i18n.language)}>
                <div className="login-welcome">
                    {
                        lossesLogin ?
                        <>
                        <p className="welcome-msg"> {user.full_name} {t('Dear')}</p>
                        <div className='m10'>
                        
                        {t('Submit the request as')}{ <b> {t('Losses')}</b>} {t('Accident message')}
                        {/* </div> */}
                        {/* <div className='m10'> */}
                        {t('Enter culprit mobile number')}
                         </div>
                        </>
                        :
                        <>
                        <div className="welcome-msg">{t('Login greeting')}</div>
                        <div>{t('Please enter your mobile number')}</div>
                        </>
                    }
                </div>
                <div className='group-input-box-phone'>
                    <i className='fas fa-mobile-alt'/>
                    <>
                        {login.mobile.map((val,i)=>(
                            <input
                                type='number'
                                className='input-box-phone'
                                id={`mobile-${i}`}
                                min="0"
                                max="9"
                                pattern="[0-9]*"
                                maxLength="1"
                                inputMode="numeric"
                                onChange={(e)=>handleChangeNumber(e,'mobile')}
                                onKeyDown={(e)=>deleteNumberChecking(e,'mobile')}
                                value={login.mobile[i]}
                                key={`mobile-${i}`}
                                onClick={()=>handleFocus('mobile')}
                                autoFocus ={i===2}
                                readOnly={i === 0 || i === 1}

                            />
                        ))}
                        </>
                </div>
                <button
                    className='btn btn-block btn-circle btn-cyan mt20 phone-next-step'
                    disabled={loader || login.mobile[10] === ''}
                    onClick={submitMobile}
                >
                    {
                        loader ?
                            <i className='fas fa-spinner fa-spin'/>
                            : t('Next step')
                    }
                </button>
                {
                    lossesLogin &&
                    <button
                    className='btn btn-block btn-circle btn-cancle mt20 phone-next-step'
                    onClick={()=> history.push("/")}
                > {t('Reject')}</button>
                }
            </div> :
            <div>
                
                {lossesLogin &&
                <p className='mb20 mt10 login-label'>
                    {t('Enter the code that send to culprit')} {<b>{t('Culprit')}</b>} {t('Accident number',{mobile: login.mobile.join('')})}
                </p>
            }
                
                {!lossesLogin &&<div className="login-label">{t('Deliverd code')}</div>}
                
                <div className='group-input-box-code'>
                    <>
                    {login.code.map((val,i)=>(
                        <input
                            type="number"
                            className='input-box-code'
                            id={`code-${i}`}
                            min="0"
                            max="9"
                            pattern="[0-9]*"
                            maxLength="1"
                            inputMode="numeric"
                            onChange={(e)=>handleChangeNumber(e,'code')}
                            onKeyDown={(e)=>deleteNumberChecking(e,'code')}
                            value={login.code[i]}
                            key={`code-${i}`}
                            onClick={()=>handleFocus('code')}
                            autoFocus ={i===0}
                        />
                    ))}
                    </>
                </div>
                {
                    signupRequired &&
                    <div>
                        <div className='input-parent withIcon rtl mt10'>
                            <input
                                value={login.fname}
                                type='text'
                                placeholder={`${t('First name')} ${type}`}
                                onChange={e => changeText(e.target.value, 'fname')}
                                // onKeyDown={(e)=>isLangPersian(e)}
                                //  onKeyPress={(e)=>isLangPersian(e)}
                                 
                            />
                            <i className='fas fa-user'/>
                        </div>
                        <div className='input-parent withIcon rtl mt10'>
                            <input
                                value={login.lname}
                                type='text'
                                placeholder={`${t('Last name')} ${type}`}
                                onChange={e => changeText(e.target.value, 'lname')}
                                //onKeyPress={(e)=>isLangPersian(e)}
                            />
                            <i className='fas fa-user'/>
                        </div>
                    </div>
                }
                <button
                    className='btn btn-block btn-circle btn-cyan mt20'
                    disabled={loader}
                    onClick={submitCode}
                    id="submit-code"
                >
                    {
                        loader ?
                            <i className='fas fa-spinner fa-spin'/> :
                            t('Confirm')
                    }
                </button>
                <div className='mt10'>
                    {
                        timer ?
                            <Timer seconds={120} onFinish={() => setTimer(false)} /> :
                            <div className='d-flex'>
                                <a className='btn btn-block btn-circle btn-green mr5' href='tel:02191065151'>
                                    {t('Contact with company')}
                                </a>
                                <button
                                    className='btn btn-block btn-circle btn-yellow ml5'
                                    disabled={loader}
                                    onClick={resendCode}
                                >
                                    {
                                        loader ?
                                            <i className='fas fa-spinner fa-spin'/> :
                                            t('Send code again')
                                    }
                                </button>
                            </div>
                    }
                </div>
            </div>
    );

}
